// @ts-nocheck
export const DATATYPES_LENGTH = {
  STRING: 255,
  TEXT: 65535,
  INT_10: 4294967295,
  DECIMAL_13_3: 9999999999.999,
  DECIMAL_15_5: 999999999999.999,
};
